import React from 'react'

import clsx from 'clsx'

import Grid from 'components/Grid'
import TopicTag from 'components/TopicTag'
import { EventContext } from 'context/EventContext'
import useViewport from 'hooks/useViewport'

import BlockHeading from '../BlockHeading'

import classes from './TopicList.module.scss'

const useTopicRow = () => {
  const { up, is } = useViewport()
  if (up('md')) {
    return 4
  }

  if (is('sm')) {
    return 2
  }

  return 1
}

const TopicList = ({ topics }) => {
  const totalTopicRows = useTopicRow()

  const filteredTopics = topics.filter(topic => topic.linkedFrom?.posts?.total > 0)

  const topicsPerColumn = Math.ceil(filteredTopics.length / totalTopicRows)

  const topicsRows = Array(totalTopicRows)
    .fill([])
    .map((x, i) => filteredTopics.slice(i * topicsPerColumn, i * topicsPerColumn + topicsPerColumn))

  return (
    <div id="topics" className={clsx('TopicList', classes.root)}>
      <EventContext value={{ engagementComponent: 'resources_topics', name: 'engagement_facet_click' }}>
        <BlockHeading>Explore by topic</BlockHeading>
        <Grid container className={classes.grid} spacing={4}>
          {topicsRows.map((topicList, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <Grid data-testid="topic-column" item sm={6} md={3} xs={12} key={`${totalTopicRows}-${i}`}>
              {topicList.map((topic, index, arr) => (
                <div data-testid="topic" key={topic.slug} className={classes.topicContainer}>
                  <div className={classes.index}>
                    {(index === 0 || arr[index - 1].name[0].toLowerCase() !== topic.name[0].toLowerCase()) &&
                      topic.name[0].toUpperCase()}
                  </div>
                  <div className={classes.topic}>
                    <TopicTag topic={topic} />
                  </div>
                </div>
              ))}
            </Grid>
          ))}
        </Grid>
      </EventContext>
    </div>
  )
}

export default TopicList
